import { createContext, useContext, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AppQueryParams, Languages } from '../constants';

const ApplicationLanguageContext = createContext(null);

export const useLanguage = () => {
  const context = useContext(ApplicationLanguageContext);

  if (!context) {
    throw new Error(`Error use application language hook outside context provider`);
  }

  return context;
};

export const ApplicationLanguageProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState(
    () => localStorage.getItem(AppQueryParams.Language) || Languages.English,
  );

  const { i18n } = useTranslation();

  const [searchParams] = useSearchParams();

  const language = searchParams.get(AppQueryParams.Language);

  useEffect(() => {
    if (language) {
      setCurrentLanguage(language);
    }
  }, [language]);

  useEffect(() => {
    i18n.changeLanguage(currentLanguage);

    const htmlElement = document.getElementsByTagName('html')[0];

    htmlElement.setAttribute('dir', currentLanguage === Languages.Arabic ? 'rtl' : 'ltr');
    htmlElement.setAttribute('lang', currentLanguage);

    localStorage.setItem(AppQueryParams.Language, currentLanguage);
  }, [i18n, currentLanguage]);

  const isAr = currentLanguage === 'ar';

  return (
    <ApplicationLanguageContext.Provider
      value={{
        isRtl: isAr,
        language: currentLanguage,
        setLanguage: setCurrentLanguage,
      }}
    >
      {children}
    </ApplicationLanguageContext.Provider>
  );
};
